//react
import React from 'react';

//redux
import { connect } from 'react-redux';

//styles
import withStyles from '@material-ui/core/styles/withStyles';
import modalStyle from 'assets/jss/material-kit-pro-react/modalStyle.jsx';

//core
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Checkbox from '@material-ui/core/Checkbox';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';

//components
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import Button from 'components/CustomButtons/Button.jsx';

//icons
import Filter from '@material-ui/icons/FilterList';
import Check from '@material-ui/icons/Check';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

class UserPicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      options: [],
      selected: [],
      selectedText: '',
    };

    var options = [];
    for (var i = 0; i < this.props.users.length; i++)
      options.push({
        key: this.props.users[i].key,
        label: this.props.users[i].label,
      });
    this.state.options = options;

    this.filterResults = this.filterResults.bind(this);
    this.loadSelected = this.loadSelected.bind(this);
    this.setSelectedText = this.setSelectedText.bind(this);
    this.toggleAll = this.toggleAll.bind(this);
  }

  componentDidMount() {
    this.loadSelected();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selected !== this.props.selected) {
      this.loadSelected();
    }
  }

  // dialog open/close
  handleClickOpen(modal) {
    var x = [];
    x[modal] = true;
    this.setState(x);
  }

  handleClose(modal) {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }

  loadSelected() {
    
    var selected = [];
    for (var j = 0; j < this.props.selected.length; j++)
      selected.push(this.props.selected[j]);
    this.setState({ selected: selected }, this.setSelectedText);
  }

  // search text of users
  searchUsers(e) {
    var query = e.target.value.toLowerCase();
    var results = [];

    if (!query || query === '') results = this.props.users;
    else {
      for (var i = 0; i < this.props.locations.length; i++) {
        if (this.props.users[i].name.toLowerCase().indexOf(query) > -1) {
          results.push(this.props.users[i]);
        }
      }
    }

    results.sort(this.sortByLabel);
    this.setState({ filtered: results });
  }

  toggleUser(value) {
    const checked = this.state.selected;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({ selected: newChecked, group: '' }, () => {
      this.setSelectedText();
    });
  }

  toggleAll() {
    var selected = [];
    if (this.state.selected.length === 0) {
      for (var i = 0; i < this.state.options.length; i++)
        selected.push(this.state.options[i].key);
    }

    this.setState({ selected: selected, user: '' }, () => {
      this.setSelectedText();
    });
  }

  setSelectedText() {
    var selectedText = '';

    this.state.selected.forEach((key) => {
      for (var i = 0; i < this.props.users.length; i++) {
        if (this.props.users[i].key === key) {
          selectedText = selectedText + this.props.users[i].label + ', ';
          break;
        }
      }
    });

    if (selectedText.length > 0)
      // remove trailing comma
      selectedText = selectedText.substr(0, selectedText.length - 2);

    this.setState({ selectedText: selectedText });
  }

  filterResults() {
    this.props.onChange(this.state.selected);
    this.handleClose('modal');
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <GridContainer>
          <GridItem xs={11}>
            <CustomInput
              labelText="Users"
              inputProps={{ placeholder: 'Users' }}
              formControlProps={{ fullWidth: true }}
              value={this.state.selectedText}
              placeholder="all"
              multi
              disabled
            />
          </GridItem>
          <GridItem xs={1}>
            <IconButton
              style={{ marginTop: '14px' }}
              onClick={() => this.handleClickOpen('modal')}
            >
              <Filter />
            </IconButton>
          </GridItem>
        </GridContainer>
        <Dialog
          classes={{ root: classes.center, paper: classes.modal }}
          open={this.state.modal}
          TransitionComponent={Transition}
          keepMounted
          maxWidth={'md'}
          onClose={() => this.handleClose('modal')}
          aria-labelledby="modal-slide-title"
          aria-describedby="modal-slide-description"
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
            style={{ backgroundColor: '#efefef' }}
          >
            <GridContainer direction="row">
              <GridItem xs={12}>
                <h4 className={classes.modalTitle}>Users</h4>
              </GridItem>
            </GridContainer>
          </DialogTitle>
          <DialogContent
            style={{ backgroundColor: '#efefef', paddingBottom: '0px' }}
          >
            <GridContainer>
              <GridItem xs={12}>
                <Card>
                  <CardBody style={{ overflow: 'scroll', maxHeight: '400px' }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            style={{ padding: '3px', fontSize: '13px' }}
                          >
                            <IconButton onClick={this.toggleAll}>
                              <Check style={{ color: 'green' }} />
                            </IconButton>
                          </TableCell>
                          <TableCell
                            style={{ padding: '3px', fontSize: '13px' }}
                          >
                            Name
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.props.users.map((user, index) => (
                          <TableRow key={index}>
                            <TableCell style={{ padding: '3px' }}>
                              <Checkbox
                                tabIndex={-1}
                                onClick={() => this.toggleUser(user.key)}
                                checked={
                                  this.state.selected.indexOf(user.key) !== -1
                                    ? true
                                    : false
                                }
                                checkedIcon={
                                  <Check className={classes.checkedIcon} />
                                }
                                icon={
                                  <Check className={classes.uncheckedIcon} />
                                }
                                classes={{
                                  checked: classes.checked,
                                  root: classes.checkRoot,
                                }}
                              />
                            </TableCell>
                            <TableCell style={{ padding: '3px' }}>
                              {user.label}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </CardBody>
                </Card>
              </GridItem>
            </GridContainer>
          </DialogContent>
          <DialogActions
            style={{
              backgroundColor: '#efefef',
              paddingLeft: '17px',
              paddingTop: '-20px',
              paddingRight: '17px',
              paddingBottom: '17px',
              margin: '0px',
            }}
          >
            <GridContainer style={{ width: '100%' }}>
              <GridItem xs={12} style={{ textAlign: 'right' }}>
                <Button color="success" onClick={this.filterResults}>
                  <Filter />
                  OK
                </Button>
              </GridItem>
            </GridContainer>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

UserPicker = connect(mapStateToProps)(UserPicker);
export default withStyles(modalStyle)(UserPicker);
